import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

import { Colors } from "../../styles";

const CarouselNumbers = ({ slidesCount, currentSlide }) => {
	return (
		<Numbers>
			<Number>{currentSlide == 0 ? 1 : currentSlide}</Number>
			<Number>/</Number>
			<Number>{slidesCount}</Number>
		</Numbers>
	);
};

CarouselNumbers.propTypes = {
	slidesCount: PropTypes.number,
	currentSlide: PropTypes.number,
	toggleNexSlide: PropTypes.func,
	togglePrevSlide: PropTypes.func,
};

export default CarouselNumbers;

const Numbers = styled.div`
	display: flex;
	align-items: center;
	height: 22px;
`;
const Number = styled.span`
	width: 2rem;
	font-weight: 900;
	font-size: 1.9rem;
	line-height: 2.3rem;
	color: ${Colors.base.white};
`;
